import { useEffect, useState } from 'react';
import { Network } from '@kattana-io/common';
import { KTN_Tokens } from '../../helpers/coinIcon';
import KTNIcon from '../PairIcons/icons/KTN.svg';
import fallbackIcon from '../PairIcons/icons/placeholder.svg';
import IconProvider from '../../helpers/IconProvider';
import useIcons from '../PairIcons/useIcons';
import Text from '../../atoms/Text';
import Image, { imageSizeType } from '../../atoms/Image';
import './styles.scss';

interface ITokenInfoProps {
  chain: string;
  address: string;
  name: string;
  amount?: string;
  textSize?: number;
  textWeight?: number;
  imageSize?: imageSizeType;
}

const TokenInfo = ({
  chain,
  address,
  name,
  amount,
  textSize = 12,
  textWeight = 400,
  imageSize = 'l',
}: ITokenInfoProps) => {
  const [icon, setIcon] = useState('');

  useEffect(() => {
    const network = Network.fromChain(chain);
    if (KTN_Tokens.includes(address.toLocaleLowerCase())) {
      setIcon(KTNIcon);
    } else {
      if (network) {
        setIcon(IconProvider.createFromNetworkAndPair(network, address).url());
      } else {
        setIcon(fallbackIcon);
      }
    }
  }, [chain, address]);

  const loaded = useIcons({ icon }, !icon);

  return (
    <div className='token_info'>
      <Image
        className={`token_info__icon${
          !loaded ? ' token_info__icon--loading' : ''
        }`}
        alt={`${chain}/${address}`}
        src={icon ? icon : fallbackIcon}
        onError={() => setIcon('')}
        size={imageSize}
      />

      <Text
        size={textSize}
        className={`token_info__meta text--weight-${textWeight}`}
        style={{ title: `${name} ${amount || ''}` }}
      >
        {name} {amount}
      </Text>
    </div>
  );
};

export default TokenInfo;
